<template>
  <b-form-group :label="computedLabel" label-for="rt-device-activities-select">
    <multiselect
      id="rt-device-activities-select"
      placeholder="-"
      :searchable="false"
      :show-no-results="true"
      :allowEmpty="true"
      :disabled="loading"
      open-direction="bottom"
      :options="options"
      v-model="selectedOption"
      track-by="id"
      label="label"
    >

      <template slot="clear">
        <div
          class="multiselect__clear"
          v-if="selectedOption"
          @mousedown.prevent.stop="clearValue"
        ></div>
      </template>

    </multiselect>
  </b-form-group>
</template>
<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import {sortBy} from "lodash";

export default {
  name: "RtDeviceActivitiesSelect",
  components: {
    Multiselect,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    tLabel: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: String | Number | null,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      ready: true,
      selectedOption: null,
      options: [
        {
          id: 1,
          label: this.$t("Currently active"),
        },
        {
          id: 2,
          label: this.$t("Not active for 7 days to 1 month"),
        },
        {
          id: 3,
          label: this.$t("Not active for 1 month to 6 months"),
        },
        {
          id: 4,
          label: this.$tc("Not active for more than {count} month(s)", 6, {count: 6}),
        }
      ],
    }
  },
  mounted() {
    this.$emit("ready", this.ready);
    this.loading = false;
    this.selectedOption = this.findByValue(this.value)
  },
  methods: {
    clearValue() {
      this.selectedOption = null;
    },
    findByValue(value) {
      if (!value) {
        return null;
      }

      return this.options.find(options => value.toString() === options?.id?.toString()) || null;
    }
  },
  computed: {
    computedLabel() {
      return this.tLabel ? this.$t(this.tLabel) : this.label;
    },
  },
  watch: {
    selectedOption(newValue) {
      this.$emit("input", newValue ? newValue.id : null);
    },
    value(newValue) {
      this.selectedOption = this.findByValue(newValue);
    }
  }
};
</script>
